/**
 * PhoneField - Specialized phone input
 *
 * Pre-configured with Phone icon, tel type, and appropriate defaults.
 */

import { Phone } from 'lucide-react';
import { TextField, type TextFieldProps } from './TextField';

export type PhoneFieldProps = Omit<TextFieldProps, 'type' | 'icon' | 'autoComplete'> & {
  /** Override the default icon */
  icon?: TextFieldProps['icon'];
};

export function PhoneField({
  icon = Phone,
  placeholder = '+39 XXX XXX XXXX',
  ...props
}: PhoneFieldProps) {
  return (
    <TextField
      {...props}
      type="tel"
      icon={icon}
      placeholder={placeholder}
      autoComplete="tel"
    />
  );
}
